const en_us = {}

export default en_us
